import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Yourinfo from './pages/Your_info';
import Plan from './pages/Select_plan';
import Addons from './pages/Add_ons';
import Summary from './pages/Summary';
import Confirmation from './pages/Confirmation';

function RoutesApp() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Yourinfo />} />
                <Route path='/plan' element={<Plan />} />
                <Route path='/addons' element={<Addons />} />
                <Route path='/summary' element={<Summary />} />
                <Route path='/confirmation' element={<Confirmation />} />
            </Routes>
        </BrowserRouter>
    )
}

export default RoutesApp;